import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { useEffect } from 'react'
import { useStore } from '@/store'
import { useShallow } from 'zustand/shallow'
import { is_shikhar_account } from '@/lib/utils'

export const Route = createFileRoute('/login')({
    component: RouteComponent,
})

function RouteComponent() {
    const navigate = useNavigate()
    const { accountId } = useStore(useShallow(state => ({
        accountId: state.selectedAccount.id
    })))

    useEffect(() => {
        if (is_shikhar_account(accountId)) {
            navigate({ to: '/shikhar/neworder' })
        } else {
            navigate({ to: '/orders' })
        }
    }, [accountId, navigate])

    return null
}
